import { Box, styled } from "@mui/material";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#F9F9F9",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyledContainer = styled(Container)(({ theme }) => ({
  padding: "30px 40px",
  borderRadius: "8px",
}));
export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#06214B",
  borderRadius: "20px",
  color: "#fff",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#06214B",
  },
  "&.MuiButton-sizeLarge": {
    padding: theme.spacing(0.8),
    // fontSize: theme.typography.pxToRem(15),
    width: "100%",
  },
  "&.MuiButton-sizeSubmitButton1": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "100%",
  },
  "&.MuiButton-sizeSubmitButton": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "25%",
  },
  "&.MuiButton-sizeMedium": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "75%",
  },
  "&.MuiButton-sizeSemiMedium": {
    padding: theme.spacing(2),
    fontSize: theme.typography.pxToRem(14),
    width: "100%",
  },
  "&.MuiButton-sizeHalfMedium": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "160%",
  },
  "&.MuiButton-sizeHalfLarge": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "400%",
  },
  "&.MuiButton-sizeSmall": {
    padding: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
    width: "50%",
  },
  "&.MuiButton-sizeXtraSmall": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(13),
    width: "25%",
  },
}));
export const StyledButton1 = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "20px",
  color: "#000",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#fff",
  },
  "&.MuiButton-sizeLarge": {
    padding: theme.spacing(0.8),
    // fontSize: theme.typography.pxToRem(15),
    width: "100%",
  },
  "&.MuiButton-sizeSubmitButton": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "25%",
  },
  "&.MuiButton-sizeMedium": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "75%",
  },
  "&.MuiButton-sizeSmall": {
    padding: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
    width: "50%",
  },
}));
export const StyledButton2 = styled(Button)(({ theme }) => ({
  backgroundColor: "#0866FF",
  borderRadius: "20px",
  color: "#FFF",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#06214B",
  },
  "&.MuiButton-sizeLarge": {
    padding: theme.spacing(0.8),
    // fontSize: theme.typography.pxToRem(15),
    width: "100%",
  },
  "&.MuiButton-sizeMedium": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "75%",
  },
  "&.MuiButton-sizeSmall": {
    padding: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
    width: "50%",
  },
}));

export const StyledButton3 = styled(Button)(({ theme }) => ({
  backgroundColor: "silver",
  borderRadius: "20px",
  color: "#000",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "silver",
  },
  "&.MuiButton-sizeLarge": {
    padding: theme.spacing(0.8),
    width: "100%",
  },
  "&.MuiButton-sizeMedium": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    width: "75%",
  },
  "&.MuiButton-sizeSmall": {
    padding: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
    width: "50%",
  },
  "&.MuiButton-sizeXtraSmall": {
    padding: theme.spacing(1),
    fontSize: theme.typography.pxToRem(13),
    width: "25%",
  },
}));

export const styles = {
  loginDirectly: {
    marginTop: "20px",
    textDecoration: "none",
    color: "black",
  },
  forgotPassword: {
    textDecoration: "none",
    color: "black",
  },
  viewDetail: {
    color: "#0056d2",
  },
  action: {
    color: "#000",
  },
  dialogTitle: {
    textAlign: "center",
    position: "relative",
    color: "#2f4cdd",
    text: "bold",
  },
  closeIcon: {
    position: "absolute",
    right: 8,
    top: 8,
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButton: {
    backgroundColor: "silver !important",
    color: "#bdbdbf",
    borderRadius: "20px",
  },
  listImage: {
    display: "flex",
    gap: "5px",
    whiteSpace: "nowrap",
    padding: "5px",
  },
  listSingleImage: {
    width: "100px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "5px",
    flexShrink: 0,
  },
  listMultiImage: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "5px",
    flexShrink: 0,
  },
  listMultiImageScroll: {
    backgroundColor: "#7e7c7c",
    borderRadius: "5px",
    height: "6px",
  },
  addButtonColor: { backgroundColor: "#0037ff", color: "#fff" },
  dialogtitleAddOrEdit: { fontSize: "20px", fontWeight: "bold" },
  dialogtitleAddOrEditSubmitButton: {
    backgroundColor: "rgb(0,55,255)",
    color: "#fff",
  },
  dialogtitleAddOrEditCancelButton: {
    backgroundColor: "rgb(189, 189, 191)",
    color: "rgb(252, 249, 249)",
  },
  signupShowPassword: {
    mt: 1,
    mb: 2,
    p: 2,
    bgcolor: "#f5f5f5",
    borderRadius: 1,
    border: "1px solid #e0e0e0",
    animation: "fadeIn 0.3s ease-in-out",
  },
  signupShowPasswordTypo: { mb: 1, fontWeight: 600, color: "#333" },
  signupShowPasswordBody: { margin: 0, paddingLeft: 2, color: "#666" },
  capacityWarning: { color: "#fa0001", fontWeight: "bold" },
};

export const getListMultiProofScrollStyles = (
  isScrollEnabled,
  licenseProofs
) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  maxHeight: isScrollEnabled ? "100px" : "auto",
  overflowY: isScrollEnabled ? "auto" : "hidden",
  cursor: licenseProofs.length > 1 ? "pointer" : "default",
  border: isScrollEnabled ? "1px solid #ccc" : "none",
  padding: isScrollEnabled ? "5px" : "0",
});

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "2px solid #D8DEE6",
    },
    "&:hover fieldset": {
      border: "2px solid #D8DEE6",
    },
    "&.Mui-focused fieldset": {
      border: "2px solid #D8DEE6",
    },
    "& input": {
      backgroundColor: "#fff",
      border: "#D8DEE6",
      borderRadius: "6px",
      outline: "#D8DEE6",
      paddingLeft: "10px",
    },
  },
  "& .MuiInputBase-input": {
    backgroundColor: "#fff",
    padding: "5px",
    fontSize: "13px",
    height: "30px",
    border: "none",
    outline: "none",
  },
  "& label": {
    fontSize: "13px",
    color: "#A0A0A0",
    transform: "translate(14px, 12px) scale(1)",
  },
  "& label.Mui-focused": {
    color: "#A0A0A0",
    transform: "translate(14px, -6px) scale(0.75)",
  },
  "& label.MuiFormLabel-filled": {
    transform: "translate(14px, -6px) scale(0.80)",
  },
}));

export const filterStyles = {
  style: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "20px",
  },
  filterColor: { backgroundColor: "#f4f5f9" },
  modalHeight: (rows) => ({
    height: rows && rows.length > 0 ? "auto" : "400px",
    width: "100%",
  }),
};
